import React from "react";
import { hasOwnProperty } from "maven-lib/dist/consts/edc/lib";
import { classNames } from "maven-lib/dist/utils/misc";
import { CrIcon } from "./CrIcon";
import { nl2br } from "../helper/nl2br";
import { IconPackageName } from "../interface/Icon";

type HbParagraphTextProps = { children: React.ReactNode } | { text: string | React.ReactNode };

type HbParagraphProps = HbParagraphTextProps & {
  align?: "CENTER" | "LEFT" | "RIGHT";
  margin?: 1 | 2 | 3 | 4 | 5;
  spacing?: 1 | 2 | 3 | 4 | 5;
  size?: "LARGE" | "X-LARGE" | "2X-LARGE" | "3X-LARGE" | "4X-LARGE" | "5X-LARGE" | "6X-LARGE" | "7X-LARGE" | "8X-LARGE";
  color?: "GRAY" | "WARNING" | "DANGER" | "SUCCESS" | "PRIMARY";
  bold?: boolean;
  icon?: IconPackageName;
  bullet?: boolean;
};

export function HbParagraph(props: HbParagraphProps) {
  const { align, margin, spacing, color, size, bold, icon, bullet } = props;
  const text = hasOwnProperty(props, "children") ? (
    <>{props.children}</>
  ) : typeof props.text === "string" ? (
    <>{nl2br(props.text)}</>
  ) : (
    <>{props.text}</>
  );

  return (
    <>
      <p
        className={classNames(
          "hb-paragraph",
          `--margin-${margin || 0}`,
          `--spacing-${spacing || 0}`,
          `--color-${String(color || "default").toLowerCase()}`,
          `--align-${String(align || "default").toLowerCase()}`,
          `--size-${String(size || "default").toLowerCase()}`,
          bold && "--bold",
          bullet && "--prefix-bullet"
        )}
      >
        {!!icon && (
          <span className={`hb-paragraph-icon --${icon.package.toLowerCase()}`}>
            <CrIcon icon={icon} />
          </span>
        )}
        {text}
      </p>
    </>
  );
}
